import React, { useState } from 'react';

type FilterType = 'All' | 'Pan Masala' | 'Elaichi' | 'Mukhwas';

interface Props {
  itemGroup: any[];
  selectedFilter: FilterType;
  onSelect: (filter: FilterType) => void;
}

const ProductFilter: React.FC<Props> = ({ itemGroup, selectedFilter, onSelect }) => {
  return (
    <>
      <div className='flex flex-wrap gap-1 sm:gap-1 md:gap-2 lg:gap-3 pb-4'>
        {itemGroup.map(filter => (
          <button
            key={filter}
            onClick={() => onSelect(filter)}
            className={`px-3 sm:px-3 md:px-4 lg:px-4 py-1 rounded-full border text-xs sm:text-xs md:text-base lg:text-base font-medium font-poppins transition-all duration-200 ${
              selectedFilter === filter
                ? 'bg-[#4A2D1A] text-white'
                : 'border-[#4A2D1A] text-[#4A2D1A] hover:bg-[#4A2D1A] hover:text-white'
            }`}
          >
            {filter}
          </button>
        ))}
      </div>
    </>
  );
};

export default ProductFilter;
